export default "__VITE_ASSET__81c9c645__"